import React, {Component} from "react";
import {graphql} from "react-apollo";
import VipTag from "./VipTag";
import {GET_CUSTOMER_VIP_STATUS, ON_CUSTOMER_UPDATED} from "../../queries/customers";

// Resolves VIP status for a customer on its own so callers only need a customerId.
// Customer objects are not normalised in the Apollo cache, so this subscribes for
// its own updates rather than relying on other queries refetching the customer.
class CustomerVipTag extends Component {

  componentDidMount() {
    this.subscribe();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerId !== this.props.customerId) {
      this.subscribe();
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe() {
    this.unsubscribe();
    if (!this.props.customerId || !this.props.data) return;
    this.unsubscribeToUpdates = this.props.data.subscribeToMore({
      document: ON_CUSTOMER_UPDATED,
      variables: {
        customerId: this.props.customerId
      },
      updateQuery: (prev, { subscriptionData }) => {
        this.props.data.refetch();
        return prev;
      }
    })
  }

  unsubscribe() {
    if (this.unsubscribeToUpdates) {
      this.unsubscribeToUpdates();
      this.unsubscribeToUpdates = null;
    }
  }

  render() {
    let {data} = this.props;
    if (!data || data.loading || data.error || !data.customer) return null;
    return <VipTag show={data.customer.vip} />
  }

}

const withQuery = graphql(GET_CUSTOMER_VIP_STATUS, {
  skip: (props) => !props.customerId,
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      customerId: props.customerId
    }
  })
})

export default withQuery(CustomerVipTag);
